import React from 'react';

import './Spinner.scss';

interface Props {
    // When the `highPerformance` flag is set, the component will
    // return a CSS only version.
    // Since Chrome does not hardware accelerate animations in SVGs
    // the high performance variant looks simplified, but will reduce
    // CPU usage, especially when we have to display a lot of spinners at once.
    highPerformance: boolean;
}

const Spinner: React.FunctionComponent<Props> = (props) => {
    if (props.highPerformance === true) {
        return <span className="react-spinner react-spinner--high-performance" />;
    } else {
        return (
            <svg
                className="react-spinner react-spinner--complex"
                width="65px"
                height="65px"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle
                    className="react-spinner__circle"
                    fill="none"
                    strokeWidth="4"
                    strokeLinecap="round"
                    cx="33"
                    cy="33"
                    r="30"
                />
            </svg>
        );
    }
};

export default Spinner;
